import { useCallback } from 'react';
import { SimpleEditor as SimpleEditorComponent } from '@/components/tiptap-templates/simple/simple-editor';
import { uploadNoticeImage } from 'apis/Service/ServiceBoard';
import { MAX_FILE_SIZE } from '@/lib/tiptap-utils';

const SimpleEditor = ({ value, onChange, editable = true }) => {
    // 이미지 업로드 핸들러
    const handleImageUpload = useCallback(async (file, onProgress, abortSignal) => {
        // 파일 유효성 검사
        if (!file) {
            throw new Error("No file provided");
        }

        if (file.size > MAX_FILE_SIZE) {
            throw new Error(`File size exceeds maximum allowed (${MAX_FILE_SIZE / (1024 * 1024)}MB)`);
        }

        try {
            // FormData 생성
            const formData = new FormData();
            formData.append('image', file);

            // 업로드 진행 상황 시뮬레이션
            onProgress?.({ progress: 50 });

            // API 호출
            const response = await uploadNoticeImage(formData);

            // 취소 신호 확인
            if (abortSignal?.aborted) {
                throw new Error("Upload cancelled");
            }

            // 백엔드에서 이미지 ID와 임시 URL을 반환한다고 가정
            // 응답 구조: { imageId: "...", tempUrl: "..." } 또는 { id: "...", url: "..." }
            const imageId = response?.imageId || response?.id || response?.data?.imageId || response?.data?.id;
            const tempUrl = response?.tempUrl || response?.url || response?.data?.tempUrl || response?.data?.url;
            
            if (!imageId) {
                throw new Error("Upload failed: No image ID returned");
            }

            onProgress?.({ progress: 100 });
            
            // 이미지 ID와 임시 URL을 객체로 반환
            // 임시 URL은 에디터 내 미리보기용으로 사용
            return {
                imageId: imageId,
                src: tempUrl || `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==`, // 임시 미리보기용
            };
        } catch (error) {
            console.error("Image upload error:", error);
            throw error;
        }
    }, []);
    
    return (
        <SimpleEditorComponent 
            value={value} 
            onChange={onChange} 
            imageUpload={handleImageUpload}
            editable={editable}
        />
    );
}

export default SimpleEditor;
